export const yupPhone = function () {
  return this.test({
    name: 'phone',
    exclusive: true,
    message: 'Phone number is not valid',
    test: value => {
      if (!value) return true
      const numbers = value.replace(/\D/g, '')
      return !numbers || numbers.length === 10
    }
  })
}

export const yupZip = function () {
  return this.test({
    name: 'zip',
    exclusive: true,
    message: 'Zip code is not valid',
    test: value => {
      if (!value) return false
      return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value)
    }
  })
}


// WEBPACK FOOTER //
// ./src/utils/validations.js